import { render, staticRenderFns } from "./RecentHired.vue?vue&type=template&id=19d2452a&scoped=true"
import script from "./RecentHired.vue?vue&type=script&lang=js"
export * from "./RecentHired.vue?vue&type=script&lang=js"
import style0 from "./RecentHired.vue?vue&type=style&index=0&id=19d2452a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d2452a",
  null
  
)

export default component.exports